var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "container"
  }, [_c("div", {
    staticClass: "top-wrap"
  }), _c("div", {
    staticStyle: {
      width: "100%",
      display: "flex",
      "flex-direction": "column"
    }
  }, [_c("div", {
    staticClass: "superBar"
  }, [_c("div", {
    on: {
      click: _vm.back
    }
  }, [_c("img", {
    staticStyle: {
      "margin-top": "3vw",
      "margin-right": "2vw"
    },
    attrs: {
      src: require("../../assets/images/arrow.png"),
      alt: ""
    }
  })]), _c("div", {
    staticClass: "title"
  }, [_vm._v(_vm._s(this.isShow ? _vm.title : _vm.$t("Questionnaire")))]), _c("div", {
    staticClass: "img-wrap"
  })])]), _c("div", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.isSuccess,
      expression: "isSuccess"
    }],
    staticClass: "successWrap"
  }, [_c("div", {
    staticClass: "box"
  }, [_c("img", {
    attrs: {
      src: require("../../assets/images/ic_release_success.png"),
      alt: ""
    }
  }), _c("span", {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t("Success")) + "!")]), _c("span", {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.$t("YQHBS")))]), _c("span", {
    staticClass: "text1"
  }, [_vm._v(_vm._s(_vm.$t("TYFYP")))]), _c("div", {
    staticClass: "btn1",
    on: {
      click: _vm.back
    }
  }, [_vm._v(_vm._s(_vm.$t("Confirm")))])])]), _c("div", {
    staticClass: "img-con-top"
  }, [_c("div", {
    staticClass: "text-con"
  }, [_c("span", {
    staticClass: "bottom",
    staticStyle: {
      "word-break": "break-word"
    }
  }, [_vm._v(_vm._s(_vm.content))])]), _c("img", {
    attrs: {
      src: require("../../assets/images/pic_questionnaire.png"),
      alt: ""
    }
  })]), _c("div", {
    class: ["btn", {
      active: _vm.isActive
    }],
    on: {
      click: _vm.toAnswer
    }
  }, [_vm._v(_vm._s(_vm.$t("start")))]), _vm.isShow ? _c("div", {
    staticClass: "wrap"
  }, [_c("div", {
    staticClass: "question"
  }, [_c("div", {
    staticClass: "close",
    on: {
      click: function click($event) {
        $event.stopPropagation();
        return _vm.hidePop.apply(null, arguments);
      }
    }
  }, [_c("img", {
    attrs: {
      src: require("../../assets/images/Nav-Close.png"),
      alt: ""
    }
  })]), _c("div", {
    staticClass: "num"
  }, [_c("span", [_vm._v("Q" + _vm._s(_vm.num))]), _vm.questions[_vm.num - 1].type === 1 ? _c("span", [_vm._v("/" + _vm._s(_vm.questions.length) + " [" + _vm._s(_vm.$t("Singlechoice")) + "]")]) : _vm._e(), _vm.questions[_vm.num - 1].type === 2 ? _c("span", [_vm._v("/" + _vm._s(_vm.questions.length) + " [" + _vm._s(_vm.$t("MultiChoice")) + "]")]) : _vm._e(), _vm.questions[_vm.num - 1].type === 3 ? _c("span", [_vm._v("/" + _vm._s(_vm.questions.length) + " [" + _vm._s(_vm.$t("Completion")) + "]")]) : _vm._e()]), _c("div", {
    staticClass: "progress"
  }, [_c("div", {
    staticClass: "top",
    style: "width:" + _vm.lineWidth + "px;"
  }), _c("div", {
    staticClass: "bottom"
  })]), _c("h4", [_vm._v(_vm._s(_vm.questions[_vm.num - 1].title))])]), _vm.questions[_vm.num - 1].type === 1 && _vm.isShowOptions ? _c("div", {
    staticClass: "item",
    attrs: {
      id: "backTop"
    }
  }, _vm._l(_vm.options, function (item, index) {
    return _c("span", {
      key: index,
      class: [{
        active: item.selected
      }],
      on: {
        click: function click($event) {
          return _vm.onSelect(index);
        }
      }
    }, [_vm._v(_vm._s(item.title))]);
  }), 0) : _vm._e(), _vm.questions[_vm.num - 1].type === 2 && _vm.isShowOptions ? _c("div", {
    staticClass: "item"
  }, _vm._l(_vm.options, function (item, index) {
    return _c("span", {
      key: index,
      class: [{
        active: item.selected
      }],
      on: {
        click: function click($event) {
          return _vm.onMultipleSelect(index);
        }
      }
    }, [_vm._v(_vm._s(item.title))]);
  }), 0) : _vm._e(), _vm.questions[_vm.num - 1].type === 3 ? _c("van-field", {
    attrs: {
      autosize: "",
      disabled: _vm.is_finish,
      type: "textarea",
      placeholder: _vm.$t("SaySomething"),
      "show-word-limit": ""
    },
    model: {
      value: _vm.message,
      callback: function callback($$v) {
        _vm.message = $$v;
      },
      expression: "message"
    }
  }) : _vm._e(), _c("div", {
    staticClass: "btn-con"
  }, [_c("div", {
    class: ["last", {
      active: !_vm.isStart
    }],
    on: {
      click: _vm.last
    }
  }, [_vm._v(_vm._s(_vm.$t("Back")))]), !_vm.isEnd ? _c("div", {
    staticClass: "last active",
    on: {
      click: _vm.next
    }
  }, [_vm._v(_vm._s(_vm.$t("Next")))]) : _c("div", {
    staticClass: "last",
    on: {
      click: function click($event) {
        return _vm.next("submit");
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("submit")))])])], 1) : _vm._e()]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };